import { render, staticRenderFns } from "./problemDetail.vue?vue&type=template&id=1854c258&scoped=true&"
import script from "./problemDetail.vue?vue&type=script&lang=js&"
export * from "./problemDetail.vue?vue&type=script&lang=js&"
import style0 from "./problemDetail.vue?vue&type=style&index=0&id=1854c258&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854c258",
  null
  
)

export default component.exports